import { gql } from '@apollo/client';

export const SET_PURCHASER = gql`
  mutation SET_PURCHASER($registrationId: String!) {
    setPurchaser(registrationId: $registrationId)
  }
`;
